<template>
    <div>
        <file-title-component :title="title"></file-title-component>
        <input id="fileInput" ref="fileInput" type="file" style="visibility:hidden" @change="fileChosen"/>
        <div class="row" v-if="(fileState === 'file_uploaded') || (fileState === 'file_selected')">
            <div class="col">
                <b-form-group id="filename-form-group"
                              class="o-label"
                              :label="$t('speeches.documents.filenameLabel')"
                              label-for="filename-input">
                    <b-form-input id="filename-input"
                                  class="o-form"
                                  type="text"
                                  v-model="localFile.name"
                                  required
                                  placeholder="keine Datei vorhanden"
                                  disabled>
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col button-div">
                <a href="javascript:void(0)" v-if="fileState === 'no_file_selected'" v-on:click="openInput">
                    {{$t('speeches.documents.uploadButton')}}
                </a>
                <b-button class="o-button" v-if="fileState === 'file_uploaded'" v-on:click="deleteFile">
                    {{$t('speeches.documents.deleteButton')}}
                </b-button>
                <b-button class="o-button" v-if="fileState === 'file_uploaded'" v-on:click="download">
                    {{$t('speeches.documents.downloadButton')}}
                </b-button>
            </div>
        </div>
        <div class="gap-div"></div>
        <div class="getter-hook">{{localFile}}</div>
    </div>
</template>

<script>
    import * as firebase from 'firebase'
    import API from '../../services/API'
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        SPEECHES_NAMESPACE,
        SPEECHES_ACTION_SAVE_FILE,
        SPEECHES_MUTATION_FILE,
        FILE_GETTER
    } from '../../store/modules/speeches-types'
    import FileTitleComponent from '../shared/FileTitleComponent'
    // import i18n from '../../assets/i18n/lang'

    export default {
        name: 'FileUpload',
        components: {
            'file-title-component': FileTitleComponent
        },
        props: ['category', 'title'],
        data () {
            return {
                selectedFile: null,
                fileState: 'no_file_selected'
            }
        },
        computed: {
            ...mapGetters(SPEECHES_NAMESPACE, [
                FILE_GETTER
            ]),
            localFile: {
                get () {
                    let file = this.speechesFile(this.category)
                    if (file.length === 0) this.updateFileState('no_file_selected')
                    else if (!file.name && !file.url) this.updateFileState('no_file_selected')
                    else if (file.name !== null && file.url === null) this.updateFileState('file_selected')
                    else if (file.name !== null && !file.url) this.updateFileState('file_selected')
                    else if (file.name === null || file.url === null) this.updateFileState('no_file_selected')
                    else this.updateFileState('file_uploaded')
                    return file
                },
                set (value) { this.updateFile({category: this.category, file: value}) }
            }
        },
        methods: {
            ...mapMutations(SPEECHES_NAMESPACE, {
                updateFile: SPEECHES_MUTATION_FILE
            }),
            ...mapActions(SPEECHES_NAMESPACE, {
                saveFile: SPEECHES_ACTION_SAVE_FILE
            }),
            updateFileState (state) {
                this.fileState = state
            },
            updateName (name) {
                this.localFile = {name: name, url: this.localFile.url}
            },
            updateUrl (url) {
                this.localFile = {name: this.localFile.name, url: url}
            },
            openInput () {
                this.$refs.fileInput.click()
            },
            fileChosen (event) {
                this.updateName(this.$refs.fileInput.files[0].name)
                this.selectedFile = this.$refs.fileInput.files[0]
                this.fileState = 'file_selected'
                this.upload()
            },
            upload () {
                const randStamp = (Date.now() / 1000 | 0) + Math.floor(Math.random() * 1000) + 1
                const filePath = 'user/' + firebase.auth().currentUser.uid + '/' + randStamp + '_' + this.localFile.name
                firebase.storage().ref().child(filePath).put(this.selectedFile)
                    .then((snapshot) => {
                        this.updateUrl(filePath)
                        this.save()
                        this.fileState = 'file_uploaded'
                    })
                    .catch((error) => console.log(error))
            },
            save () {
                const filePayload = {name: this.localFile.name, url: this.localFile.url}
                this.saveFile({category: this.category, file: filePayload})
            },
            download () {
                API.downloadFile(this.localFile.name, this.localFile.url)
                    .then((data) => {
                        return this.insertDownloadlink(data)
                    })
                    .catch((error) => console.log(error.message))
            },
            insertDownloadlink (data) {
                return new Promise(
                    (resolve, reject) => {
                        const link = document.createElement('a')
                        link.href = window.URL.createObjectURL(new Blob([data]))
                        link.setAttribute('download', this.localFile.name)
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        resolve()
                    }
                )
            },
            deleteFile () {
                firebase.storage().ref().child(this.localFile.url).delete()
                    .then((snapshot) => {
                        this.updateUrl()
                        this.updateName()
                        this.save()
                        this.fileState = 'no_file_selected'
                    })
                    .catch((error) => console.log(error))
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }

    .gap-div {
        padding-bottom: 40px;
    }

    .getter-hook {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/FileUploadComponent.vue